var _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductScheduleSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 48216638"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42
  })), /*#__PURE__*/React.createElement("g", {
    id: "g810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2881_53024",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 27,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path816",
    d: "M8 7.59039H34.4096V34H8V7.59039Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2881_53024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path822",
    d: "M33.3776 20.6408V10.6856H9.03125V32.9688H20.0181",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path826",
    d: "M14.2422 12.748V8.62154",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path830",
    d: "M28.168 12.748V8.62154",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path834",
    d: "M9.08203 15.8438H33.3768",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path838",
    d: "M21.2031 12.748V8.62154",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path842",
    d: "M24.7695 29.6763L28.4267 33.123L34.4108 26.5264",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductScheduleSelect);
export default __webpack_public_path__ + "static/media/icon_product_schedule_select.d7d316f92e91297d32b2171a3de82382.svg";
export { ForwardRef as ReactComponent };